import { UserAuth0Details } from "../types/UserAuth0Details";

export const EMPTY_USER_AUTH0_DETAILS: UserAuth0Details = {
  auth0Id: "",
  email: "",
  passwordChangeDate: "",
  createdDate: "",
  accessToken: "",
};
